import { useAppDispatch, useAppSelector } from '../reducer/hooks';
import { useQuery } from 'react-query';
import APIs from '../api';
import { selectChainList, setChainsList } from '../reducer/chainSlice';

interface IProps {
  shouldFetch?: boolean;
}

const useChains = (props: IProps = {}) => {
  const { shouldFetch } = props;

  const dispatch = useAppDispatch();
  const { list: chainList } = useAppSelector(selectChainList);

  const handleQuery = async () => {
    const res = await APIs.Query.getChainsQuery();
    return res;
  };

  useQuery(['chainsList'], handleQuery, {
    onSuccess: (data) => {
      dispatch(setChainsList(data));
    },
    enabled: shouldFetch,
  });

  const getChainInfo = (chainType: number, chainId: number | string) => {
    return chainList.find(
      (chain) =>
        Number(chain.chainType) === Number(chainType) && Number(chain.chainId) === Number(chainId)
    );
  };

  const getChainInfoById = (id: string) => {
    return chainList.find((chain) => chain.id === id);
  };

  return {
    chainList,
    getChainInfo,
    getChainInfoById,
  };
};

export default useChains;
